import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import { SearchMenuStates } from 'components/Search/type'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { rem } from 'polished'
import React, { useCallback, useContext, useRef } from 'react'
import styled from 'styled-components'
import CruiseWhenField from './CruiseWhenField'
import CruiseWhenList from './CruiseWhenList'
import { mediaQueryUp } from 'components/utils/breakpoint'
import cx from 'clsx'

const CruiseWhenInputFilterWrapper = styled.div`
  &.active {
    position: relative;

    ${mediaQueryUp.md} {
      position: static;
    }
  }
`

const VendorsDropdown = styled(Dropdown)`
  left: ${rem(0)} !important;
`

function CruiseWhenInputFilter({ onChange }: { onChange: (values: App.CruiseGlobalFilters) => void}) {
  const dropdownTriggerRef = useRef<HTMLButtonElement>()

  const { activeMenu } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const showDropdown = activeMenu === SearchMenuStates.CruiseWhen

  const toggleDropdown = useCallback(() => {
    const nextMenu = showDropdown ? SearchMenuStates.Closed : SearchMenuStates.CruiseWhen
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: nextMenu })
  }, [searchDispatch, showDropdown])

  return (
    <CruiseWhenInputFilterWrapper className={cx({ active: showDropdown })}>
      <CruiseWhenField ref={dropdownTriggerRef} onClick={toggleDropdown} />
      <VendorsDropdown
        triggerRef={dropdownTriggerRef}
        open={showDropdown}
        onClose={toggleDropdown}
        floatingStrategy="absolute"
        width="100%"
        position="bottom-start"
      >
        <DropdownContainer>
          <CruiseWhenList onClose={toggleDropdown} onChange={onChange} />
        </DropdownContainer>
      </VendorsDropdown>
    </CruiseWhenInputFilterWrapper>
  )
}

export default CruiseWhenInputFilter
